export default __webpack_public_path__ + "static/media/doitnow.15529be4.svg";